export const FilterPatentInFolderService = Symbol('FilterPatentInFolderService');
